"use client";

import { useEffect, useMemo, useState } from 'react';
import styles from './_tab-and-toggle-navigation.module.scss';
import Button from '@/components/button';
import { renderToString } from 'react-dom/server';
import PageLoadOnlyAnchor from '@/components/page-load-only-anchor';

export default function HcpClinicalInformationTabAndToggleNavigation({
  setTabIndex,
  setToggleindex,
  tabIndex,
  toggleIndex,
}) {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [currentToggleIndex, setCurrentToggleIndex] = useState(0);

  const hashData = useMemo(() => [
    ['trial-1', 'trial-1-efficacy', 'trial-1-safety'],
    ['trial-2', 'trial-2-efficacy', 'trial-2-safety'],
  ], []);

  useEffect(() => {
    setCurrentTabIndex(tabIndex);
  }, [tabIndex]);

  useEffect(() => {
    setCurrentToggleIndex(toggleIndex);
  }, [toggleIndex]);

  const tabs = useMemo(() => [
    <>CAHtalyst<sup>&reg;</sup> Pediatric</>,
    <>CAHtalyst<sup>&reg;</sup> Adult</>
  ], []);

  const tabsGtm = useMemo(() => [
    'CAHtalyst Pediatric',
    'CAHtalyst Adult'
  ], []);

  const toggles = useMemo(() => [
    <>Trial Design</>,
    <>Efficacy</>,
    <>Safety</>
  ], []);

  useEffect(() => {
    setTabIndex && setTabIndex(currentTabIndex);
  }, [currentTabIndex, setTabIndex]);

  useEffect(() => {
    setToggleindex && setToggleindex(currentToggleIndex);
  }, [currentToggleIndex, setToggleindex]);

  /* function handleClick(e) {
    const i = e.currentTarget.dataset.index;

    if (i !== undefined && i !== null) {
      setCurrentTabIndex(parseInt(i));
      setCurrentToggleIndex(1);
    }
  }

  function handleToggleClick(e) {
    const i = e.currentTarget.dataset.index;

    if (i !== undefined && i !== null) {
      setCurrentToggleIndex(parseInt(i));
    }
  } */

  return (
    <>
      <PageLoadOnlyAnchor anchorId="trial-1" offsetY={-24} />
      <PageLoadOnlyAnchor anchorId="trial-1-efficacy" offsetY={-24} />
      <PageLoadOnlyAnchor anchorId="trial-1-safety" offsetY={-24} />
      <PageLoadOnlyAnchor anchorId="trial-2" offsetY={-24} />
      <PageLoadOnlyAnchor anchorId="trial-2-efficacy" offsetY={-24} />
      <PageLoadOnlyAnchor anchorId="trial-2-safety" offsetY={-24} />
      <section className={styles.container}>
        <div className="container container--px-0">
          <ul className={styles.tabs}>
            {tabs?.map((tab, i) => (
              <li key={`tab_key_${i}`}>
                <Button
                  customClass={i === currentTabIndex ? styles.active : ''}
                  data-index={i}
                  href={`/clinical-information#${hashData[i][1]}`}
                  data-gtm-event-category="Action"
                  data-gtm-event-action="Click"
                  data-gtm-event-label={tabsGtm[i]}
                >
                  <span>
                    {tab}
                  </span>
                </Button>
              </li>
            ))}
          </ul>
          <ul className={styles.toggles}>
            {toggles?.map((toggle, i) => (
              <li key={`toggle_key_${i}`}>
                <Button
                  customClass={i === currentToggleIndex ? styles.active : ''}
                  data-index={i}
                  href={`/clinical-information#${hashData[tabIndex][i]}`}
                  data-gtm-event-category="Action"
                  data-gtm-event-action="Click"
                  data-gtm-event-label={renderToString(toggle)}
                >
                  <span>
                    {toggle}
                  </span>
                </Button>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
